export const ongoingResponseOptions = [
  {
    label: 'Work Ongoing',
    key: 1,
    value: { json: 'workOngoing', responseType: 'WORK_ONGOING' },
  },
  {
    label: 'Phased',
    key: 2,
    value: { json: 'phaseTicket', responseType: 'PHASE_TICKET' },
  },
  {
    label: 'Negotiate new start time',
    key: 3,
    value: {
      json: 'negotiateNewStart',
      responseType: 'NEGOTIATE_NEW_START_TIME',
    },
  },
  {
    label: 'Excavated Before Marked (Ongoing)',
    key: 21,
    value: {
      json: 'excavatedBeforeMarkedOngoing',
      responseType: 'EXCAVATED_BEFORE_MARKED_ONGOING',
    },
  },
  {
    label: 'No delineation (ongoing)',
    key: 4,
    value: { json: 'noDelineation', responseType: 'NO_DELINEATION_ONGOING' },
  },
  {
    label: 'Attempted to contact excavator',
    key: 5,
    value: {
      json: 'attemptedContact',
      responseType: 'ATTEMPTED_TO_CONTACT_EXCAVATOR',
    },
  },
];

export const completedResponseOptions = [
  {
    label: 'Facilities marked',
    key: 6,
    value: { json: 'facilitiesMarked', responseType: 'FACILITY_MARKED' },
  },
  {
    label: 'No conflict',
    key: 7,
    value: { json: 'noConflict', responseType: 'NO_CONFLICT' },
  },
  {
    label: 'No conflict screened',
    key: 8,
    value: { json: 'noConflictScreened', responseType: 'NO_CONFLICT_SCREENED' },
  },
  {
    label: 'No delineation (completed)',
    key: 9,
    value: { json: 'noDelineation', responseType: 'NO_DELINEATION_COMPLETE' },
  },
  {
    label: 'No Excavation To Take Place',
    key: 10,
    value: {
      json: 'noExcavationToTakePlace',
      responseType: 'NO_EXCAVATION_TO_TAKE_PLACE',
    },
  },
  {
    label: 'No remark required',
    key: 11,
    value: { json: 'noRemarkRequired', responseType: 'NO_REMARK_REQUIRED' },
  },
  {
    label: 'Located by PG&E crew',
    key: 12,
    value: { json: 'locatedByCrew', responseType: 'LOCATED_BY_PGE_CREW' },
  },
  {
    label: 'Bad ticket info',
    key: 13,
    value: { json: 'badTicketInfo', responseType: 'BAD_TICKET_INFO' },
  },
  {
    label: 'Excavated before marked',
    key: 14,
    value: {
      json: 'excavatedBeforeMarked',
      responseType: 'EXCAVATED_BEFORE_MARKED',
    },
  },
  {
    label: 'No access to delineated area',
    key: 15,
    value: {
      json: 'noAccessToDelineatedArea',
      responseType: 'NO_ACCESS_TO_DELINEATED_AREA',
    },
  },
  {
    label: 'Expired ticket',
    key: 26,
    value: {
      json: 'expiredTicket',
      responseType: 'EXPIRED_TICKET',
    },
  },
  {
    label: 'Records provided',
    key: 31,
    value: {
      json: 'recordsProvided',
      responseType: 'RECORDS_PROVIDED',
    },
  },
  // {
  //   label: 'Duplicate Ticket',
  //   key: 16,
  //   value: { json: 'duplicateTicket', responseType: 'DUPLICATE_TICKET' }
  // }
];

export const otherResponseOptions = [
  {
    label: 'fieldMeet',
    key: 17,
    value: { json: 'scheduleFieldMeet', responseType: 'SCHEDULE_FIELD_MEET' },
  },
  {
    label: 'standby',
    key: 18,
    value: { json: 'scheduleStandby', responseType: 'SCHEDULE_STANDBY' },
  },
  {
    label: 'Close Standby',
    key: 30,
    value: { json: 'closeStandby', responseType: 'CLOSE_STANDBY' },
  },
  // {
  //   label: 'appendComments',
  //   key: 19,
  //   value: { json: 'appendComments', responseType: null },
  // },
  {
    label: 'notesAndPhotos',
    key: 32,
    value: { json: 'notesAndPhotos', responseType: 'NOTES_AND_PHOTOS' },
  },
];

export const fieldMeetResponseOptions = [
  {
    label: 'Reschedule Field Meet',
    key: 17,
    value: { json: 'scheduleFieldMeet', responseType: 'SCHEDULE_FIELD_MEET' },
  },
  {
    label: 'Complete Field Meet',
    key: 20,
    value: { json: 'completeFieldMeet', responseType: 'COMPLETE_FIELD_MEET' },
  },
  ...(process.env.REACT_APP_FM2_FORM === 'true'
    ? [
        {
          label: 'Complete Field Meet 2 (WIP)',
          key: 33,
          value: { json: 'completeFieldMeet2', responseType: 'COMPLETE_FIELD_MEET' },
        },
      ]
    : []),
  {
    label: 'Close Field Meet',
    key: 21,
    value: { json: 'closeFieldMeet', responseType: 'CLOSE_FIELD_MEET' },
  },
  {
    label: 'Unable To Contact Excavator(ongoing)',
    key: 25,
    value: {
      json: 'unableToContactExcavatorFieldMeet',
      responseType: 'UNABLE_TO_CONTACT_EXCAVATOR_FIELD_MEET',
    },
  },
  {
    label: 'Completed By 1st or 2nd Party Excavators',
    key: 23,
    value: {
      json: 'locatedByCrewFieldMeet',
      responseType: 'LOCATED_BY_PGE_CREW_FIELD_MEET',
    },
  },
  {
    label: 'Excavated Before Field Meet',
    key: 22,
    value: {
      json: 'excavatedBeforeFieldMeet',
      responseType: 'EXCAVATED_BEFORE_FIELD_MEET',
    },
  },
  {
    label: 'No Excavation to Take Place Field Meet',
    key: 24,
    value: {
      json: 'noExcavationToTakePlaceFieldMeet',
      responseType: 'NO_EXCAVATION_TO_TAKE_PLACE_FIELD_MEET',
    },
  },
];

export const standbyResponseOptions = [
  {
    label: 'Schedule Standby',
    key: 27,
    value: { json: 'scheduleStandby', responseType: 'SCHEDULE_STANDBY' },
  },
  // {
  //   label: 'Reassign Standby',
  //   key: 30,
  //   value: { json: 'reassignStandby', responseType: 'REASSIGN_STANDBY' }
  // },
  {
    label: 'Close Standby',
    key: 29,
    value: { json: 'closeStandby', responseType: 'CLOSE_STANDBY' },
  },
  {
    label: 'Cancel Standby',
    key: 28,
    value: { json: 'cancelStandby', responseType: 'CANCEL_STANDBY' },
  },
];
